<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { _ } from 'svelte-i18n';

  import LoadingIcon from '../../components/icons/LoadingIcon.svelte';

  import { AppState, SetIconsBackground } from '../../etc/stores';
  import { sleep } from '../../etc/utils';

  import Page from '../../components/misc/Page.svelte';
  import Heading from '../../components/typography/Heading.svelte';
  import Text from '../../components/typography/Text.svelte';
  import { replaceVariables } from '../../i18n';

  export let showFooterNextPage = false;

  const businessName = $AppState.business.name;
  const dispatch = createEventDispatcher();

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`loading_page.${text}`), values);
  };

  const onChangeShowFooter = (show: boolean) => {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        footerVisibility: show
      }
    }));
  };

  async function handleFlow() {
    await sleep(2000);
    dispatch('complete');
  }

  onDestroy(() => {
    onChangeShowFooter(showFooterNextPage);
  });

  onMount(() => {
    onChangeShowFooter(false);
    SetIconsBackground('light');

    handleFlow();
  });
</script>

<div class="twism-page">
  <Page padding="0 24px 16px">
    <div class="twism-loading-page">
      <div class="twism-loading-page__loading">
        <LoadingIcon />
      </div>
      <Heading
        component="h2"
        type="h2"
        class="twism-loading-page__text"
        textAlign="center"
      >
        {@html t('text')}
      </Heading>
    </div>
    <div class="twism-loading-page__footer">
      <Text component="p" type="small" color="#012A5A" textAlign="center">
        {@html replaceVariables($_('common.footer'), { businessName })}
      </Text>
    </div>
  </Page>
</div>

<style lang="scss">
  :global(.twism-loading-page__text) {
    font-weight: 500 !important;
    line-height: 33.6px !important;
    margin-top: 24px !important;
    letter-spacing: -0.005em !important;
    max-width: 311px !important;
  }

  .twism-loading-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    transform: translateY(-32px);

    &__loading {
      height: 64px;
      width: 64px;
      -webkit-animation: spin 1s linear infinite;
      -moz-animation: spin 1s linear infinite;
      animation: spin 1s linear infinite;
    }

    &__footer {
      opacity: 0.5;
      position: absolute;
      bottom: 16px;
      width: calc(100% - 48px);
    }
  }

  .twism-page {
    z-index: 10;
  }

  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
